export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const COOKIE_KEY = process.env.NEXT_PUBLIC_COOKIE_KEY;
